import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import { TabContent, Tabs } from "@bookips/sds";
import React, { useMemo } from "react";
export const CouponFilterSection = (param)=>{
    let { subject , category , handleCategory , handleSubject , filterList  } = param;
    const tabs = useMemo(()=>{
        return filterList.map((filter)=>({
                value: filter.id,
                label: /*#__PURE__*/ _jsxs("span", {
                    className: "flex items-center gap-2",
                    children: [
                        filter.title,
                        /*#__PURE__*/ _jsx("span", {
                            className: "text-gray-300",
                            children: filter.count
                        })
                    ]
                })
            }));
    }, [
        filterList
    ]);
    const selectedFilter = filterList.find((filter)=>filter.id === subject);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col gap-3",
        children: [
            /*#__PURE__*/ _jsx(Tabs, {
                size: "lg",
                value: subject,
                tabs: tabs,
                onValueChange: handleSubject,
                children: tabs.map((tab)=>/*#__PURE__*/ _jsx(TabContent, {
                        value: tab.value,
                        className: "hidden"
                    }, tab.value))
            }),
            /*#__PURE__*/ _jsx("ul", {
                className: "flex gap-3 overflow-x-auto whitespace-nowrap",
                children: selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.categoryItems.map((item, idx)=>{
                    const isSelected = category === item.title;
                    return /*#__PURE__*/ _jsx("li", {
                        onClick: ()=>handleCategory(item.title),
                        className: cn("cursor-pointer rounded-md border px-3 py-1.5 text-sm transition-colors", "text-gray-500 border-gray-100 hover:bg-indigo-50 hover:text-indigo-500", "max-sm:px-2 max-sm:py-1 max-sm:text-xs", isSelected && "bg-indigo-50 text-indigo-500 border-indigo-200 font-semibold"),
                        children: item.title
                    }, idx);
                })
            })
        ]
    });
};
